import { render } from "./LoginButtonComponent.vue?vue&type=template&id=5714e78e&scoped=true"
import script from "./LoginButtonComponent.vue?vue&type=script&lang=js"
export * from "./LoginButtonComponent.vue?vue&type=script&lang=js"

import "./LoginButtonComponent.vue?vue&type=style&index=0&id=5714e78e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5714e78e"]])

export default __exports__